import React from 'react';
import ContentCarousel from './ContentCarousel';

const PagesPreviewCarousel = ({ cards, blockHeading }) => {
  const responsiveSettings = [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1.15,
      },
    },
    {
      breakpoint: 1250,
      settings: {
        slidesToShow: 2,
      },
    },
  ];

  return (
    <div className="pages-preview-carousel">
      <h2 className="pages-preview-carousel__heading">{blockHeading}</h2>
      <ContentCarousel responsive={responsiveSettings} totalNumberOfSlides={cards.length}>
        {cards.map((card, index) => (
          <a
            key={index}
            className="pages-preview-carousel__card"
            href={card.url}
          >
            <img
              className="pages-preview-carousel__card-image"
              src={card.imageUrl}
              width="300"
              height="320"
              alt={card.title}
            />
            <h3 className="pages-preview-carousel__card-title">{card.title}</h3>
            <p className="pages-preview-carousel__card-description">
              {card.description}
            </p>
          </a>
        ))}
      </ContentCarousel>
    </div>
  );
};

export default PagesPreviewCarousel;
